export enum SurveyBuilderTab {
  Questions = 'Questions',
  Publication = 'Publication',
}
